export const AMOUNT_MAX_DECIMALS = 5;
export const AMOUNT_MAX_VALUE = 10_000_000;

// Acepta estados intermedios mientras se escribe ('', '12', '12.', '.5'): solo dígitos y un punto.
const AMOUNT_INPUT_PATTERN = new RegExp(`^\\d*(\\.\\d{0,${AMOUNT_MAX_DECIMALS}})?$`);
const POSITIVE_AMOUNT_PATTERN = new RegExp(`^\\d+(\\.\\d{1,${AMOUNT_MAX_DECIMALS}})?$`);

export const INVALID_AMOUNT_MESSAGE = `Ingresa un monto válido: solo números positivos con máximo ${AMOUNT_MAX_DECIMALS} decimales.`;
export const AMOUNT_MAX_VALUE_MESSAGE = `El monto no puede ser mayor a ${AMOUNT_MAX_VALUE.toLocaleString('en-US')}.`;
export const AMOUNT_RANGE_MESSAGE = 'El monto mínimo no puede ser mayor que el monto máximo.';
export const AMOUNT_EQUAL_MESSAGE = 'El monto mínimo y el monto máximo no pueden ser iguales.';

export const isAmountInputAllowed = (value: string): boolean => AMOUNT_INPUT_PATTERN.test(value);

export const isValidPositiveAmount = (value: string): boolean => POSITIVE_AMOUNT_PATTERN.test(value);

export const isAmountAboveMax = (value: string): boolean =>
  isValidPositiveAmount(value) && Number(value) > AMOUNT_MAX_VALUE;

const isEmptyOrValidAmount = (value: string): boolean =>
  value === '' || (isValidPositiveAmount(value) && !isAmountAboveMax(value));

const areBothValidAmounts = (min: string, max: string): boolean =>
  isValidPositiveAmount(min) && isValidPositiveAmount(max);

export const isAmountRangeInverted = (min: string, max: string): boolean =>
  areBothValidAmounts(min, max) && Number(min) > Number(max);

export const isAmountRangeEqual = (min: string, max: string): boolean =>
  areBothValidAmounts(min, max) && Number(min) === Number(max);

export const isAmountRangeValid = (min: string, max: string): boolean =>
  isEmptyOrValidAmount(min) && isEmptyOrValidAmount(max)
  && !isAmountRangeInverted(min, max) && !isAmountRangeEqual(min, max);
